<script>
import Mobilebtn from '../mobilebtn.svelte';
import {initializeGsapAnimation} from '../../utils';
import {onMount} from 'svelte';

let main;
let ParaDiv;
let ImageDiv;
let HeadingDiv;
let ParaDiv1;
let ParaDiv2;
let ParaDiv3;
let buttons;
onMount(onStart);
/**
*/
function onStart() {
    initializeGsapAnimation( main, ImageDiv, [{top: 'max(72.29vw, 33.69vh)', left: '-17.748vw', scale: 1,
        duration: 1}, {scale: 1.2, top: 'max(29.29vw, 13.56vh)', duration: 1}], 3);
    initializeGsapAnimation( main, ParaDiv, [{y: '-48.075vw', duration: 1}, {y: 0, duration: 1}], 3);
    initializeGsapAnimation( main, HeadingDiv, [{y: '-47.579vw', duration: 1}, {y: 0, duration: 1}], 3);
    initializeGsapAnimation( main, ParaDiv1, [{y: '-51.404vw', duration: 1}, {y: 0, duration: 1}], 3);
    initializeGsapAnimation( main, ParaDiv2, [{y: '-30.049vw', duration: 1},
        {top: 'max(86.682vw, 40.130vh)', duration: 1}], 3);
    initializeGsapAnimation( main, ParaDiv3, [{x: '4vw', y: '-30.778vw',
        duration: 1}, {x: 0, top: 'max(105.748vw, 48.957vh)', duration: 1}], 3);
    initializeGsapAnimation( main, buttons, [{top: 'max(199.577vw, 92.396vh)', duration: 1},
        {top: 'max(157.577vw, 72.952vh)', duration: 1}], 3);
}
</script>

<div class="bg" bind:this={main}>
    <div id="img1" >
        <img src="images/performersMobile/img1.svg" alt="" />
    </div>

    <div class="performers1">
        <div class="bg1" style="" bind:this={ImageDiv}>
            <img id="bg1" src="images/performersMobile/bg1.svg" alt="" />
        </div>

        <div class="sub" bind:this={ParaDiv}>
            Performers & Opus
        </div>
        <div class="h1" bind:this={HeadingDiv}>
            ACTORS & MODELS
        </div>
        <div class="des" bind:this={ParaDiv1}>
            Using <span style="color:#1C7BFF;">
                our performance capture app
            </span> , you can immortalize your likeness
            as it is today and retain it digitally forever.
        </div>
        <div class="para1" bind:this={ParaDiv2}>
            The likeness can be endlessly used by a producer and you make money
            whenever it does.
        </div>
        <div class="para2" style="" bind:this={ParaDiv3}>
            Also, as an early believer, you will be given a limited time pass to
            the Governance Council. Take part in making history, vote on
            important issues and get rewarded for it.
        </div>
        <div class="buttons" bind:this={buttons}>
            <Mobilebtn
                bgcolor='black'
                txtcolor='white'
                txtcolor2='white'
                border='solid black 0.234vw'
                state='Performer'
            />

            <Mobilebtn
                text2='(Model Seat)'
                bgcolor='white'
                txtcolor='black'
                txtcolor2='black'
                border='solid black 0.234vw'
                state='Performer'
            />
        </div>
    </div>
</div>

<style>
    .buttons {
        position: relative;
        top: max(190vw, 87.96vh);
        justify-content: center;
        gap: 2.5vw;
        display: flex;
        z-index: 5;
    }

    .bg {
        height: max(216.355vw,100.16vh);
        font-family: "Orbitron";
    }
    .performers1 {
        position: relative;
        font-family: "Orbitron";
        height: max(216.355vw,100.16vh);
        overflow: hidden;
        top: max(-73vw, -33.79vh);
    }

    #img1 {
        position: relative;
        height: 70.093vw;
        width: 27.103vw;
        top: max(19.916vw, 9.220vh);
    }
    .bg1 {
        position: absolute;
        height: 142.514vw;
        width: 133.355vw;
        left: -48.748vw;
        top: max(42.29vw, 19.57vh);
        z-index: 5;
        scale: 1.3;
    }
    #bg1 {
        height: 100%;
        width: 100%;
    }
    .sub {
        position: absolute;
        left: 67.29vw;
        top: max(88.084vw, 40.779vh);
        font-size: 2.336vw;
        font-weight: 400;
        line-height: 2.336vw;
        text-align: left;
    }
    .h1 {
        position: absolute;
        font-size: 7.009vw;
        font-weight: 900;
        line-height: 7.009vw;
        letter-spacing: 0.06em;
        text-align: left;
        left: 6.542vw;
        top: max(92.056vw, 42.618vh);
    }
    .para1,
    .para2,
    .des {
        font-family: "Orbitron";
        position: absolute;
        font-size: 2.804vw;
        font-weight: 400;
        line-height: 3.972vw;
        letter-spacing: 0.06em;
        text-align: left;
    }
    .des {
        height: 11.916vw;
        width: 87.85vw;
        left: 6.542vw;
        top: max(105.841vw, 49.00vh);
        font-weight: 600;
    }
    .para1 {
        top: max(111.682vw, 51.704vh);
        left: 58.645vw;
        width: 37.85vw;
        height: 19.86vw;
    }
    .para2 {
        height: 39.72vw;
        width: 31.075vw;
        left: 59.486vw;
        top: max(135.748vw, 62.846vh);
    }
</style>
